import { gql } from "@apollo/client";

export const GET_THUMBNAIL_SIGNED_URL = gql`
  query getSignedThumbnailUrl($input: GetThumbnailInput!) {
    getSignedThumbnailUrl(input: $input) {
      url
    }
  }
`;
